import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

export function loadEnvironment(envService: EnvironmentService) {
  const val = () => {
    return envService.init().toPromise();
  };

  return val;
}

@NgModule({ declarations: [],
    exports: [], imports: [], providers: [
        EnvironmentService,
        provideAppInitializer(() => {
        const initializerFn = (loadEnvironment)(inject(EnvironmentService));
        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class EnvironmentModule { }
